import { DebugPanelSettings, Tab } from '../types/debug'

// Keystone token-based DevTools constants
export const DEVTOOLS_TOKEN_COOKIE_NAME = 'devtools_token'
export const DEVTOOLS_TOKEN_COOKIE_TTL_SECONDS = 86400 // 1 day

export const DEVTOOLS_QUERY_PARAM = 'devtools'

export const DEVTOOLS_SESSION_ACTIVE_STORAGE_KEY = 'devtools_session_active'

export const STORAGE_KEY = 'nfa_devtool_settings'

export const DEFAULT_SETTINGS: DebugPanelSettings = {
  theme: 'dark',
  position: 'bottom-right',
  lastTab: 'console',
  dimensions: {
    width: 800,
    height: 600,
  },
  isOpen: false,
}

export const MIN_PANEL_WIDTH = 400
export const MAX_PANEL_WIDTH = 1400
export const MIN_PANEL_HEIGHT = 300
export const MAX_PANEL_HEIGHT = 900

export const PANEL_Z_INDEX = 9999

export const DEVTOOLS_TABLE_STICKY_Z_INDEX_MAX = 1010

export const DEVTOOLS_Z_INDEX_STACK_STEP = 10

export const DEVTOOLS_PANEL_DROPDOWN_Z_INDEX =
  DEVTOOLS_TABLE_STICKY_Z_INDEX_MAX + DEVTOOLS_Z_INDEX_STACK_STEP

export const DEVTOOLS_MODAL_Z_INDEX = PANEL_Z_INDEX + DEVTOOLS_Z_INDEX_STACK_STEP

export const DEVTOOLS_MODAL_MIN_HEIGHT = 'min(280px, 90dvh)'

export const DEVTOOLS_MODAL_TRANSITION_MS = 220

export const DEVTOOLS_SEGMENTED_OPTION_ACTIVE_CLASS =
  'devtools-segmented-option--active'

export const TABS: Tab[] = []

export const DEVTOOLS_CHIP_IDLE_OPACITY = 0.72
export const DEVTOOLS_MULTISELECT_DESC_OPACITY_DARK = 0.75
export const DEVTOOLS_MULTISELECT_DESC_OPACITY_LIGHT = 0.8
export const DEVTOOLS_TABLE_FALLBACK_COLUMN_WIDTH_PX = 150

const DEVTOOLS_TABLE_PAGE_SIZE_10 = 10
const DEVTOOLS_TABLE_PAGE_SIZE_25 = 25
const DEVTOOLS_TABLE_PAGE_SIZE_50 = 50
const DEVTOOLS_TABLE_PAGE_SIZE_100 = 100
export const DEVTOOLS_TABLE_PAGE_SIZE_OPTIONS = [
  DEVTOOLS_TABLE_PAGE_SIZE_10,
  DEVTOOLS_TABLE_PAGE_SIZE_25,
  DEVTOOLS_TABLE_PAGE_SIZE_50,
  DEVTOOLS_TABLE_PAGE_SIZE_100,
] as const

export const DEVTOOLS_HTTP_STATUS_OK_MIN = 200
export const DEVTOOLS_HTTP_STATUS_OK_MAX_EXCLUSIVE = 300
export const DEVTOOLS_HTTP_STATUS_CLIENT_ERROR_MIN = 400

export const DEVTOOLS_PROCESSOR_SPEED_FAST_MAX_MS = 200
export const DEVTOOLS_PROCESSOR_SPEED_MEDIUM_MAX_MS = 1000

export const DEVTOOLS_STATE_ACTIONS_MAX_DEFAULT = 100

export const DEVTOOLS_TOKEN_FIELD_MAX_DURATION_MS = 30000
export const HTTP_STATUS_INTERNAL_SERVER_ERROR = 500
export const HTTP_STATUS_NOT_FOUND = 404
export const DEVTOOLS_FEATURE_TOGGLE_COLUMN_PERCENT_BASE = 100
export const DEVTOOLS_FEATURE_TOGGLE_TRUNCATE_LEN = 10
export const DEVTOOLS_PROCESSOR_MODAL_MIN_WIDTH_PX = 200
export const DEVTOOLS_PROCESSOR_MODAL_MIN_HEIGHT_PX = 1000
export const DEVTOOLS_STATE_COPY_FEEDBACK_MS = 2000
export const DEVTOOLS_STATE_JSON_TREE_MAX_STRING = 100
export const DEVTOOLS_TEMPLATE_STATS_GAP_PX = 100
export const DEVTOOLS_REQUEST_TRACKER_MAX_ENTRIES = 1000
export const DEVTOOLS_AUTH_REDIRECT_MS = 1000
export const DEVTOOLS_KEYSTONE_TOKEN_MIN_PARTS = 5
export const DEVTOOLS_KEYSTONE_TOKEN_SECONDS = 60
export const DEVTOOLS_KEYSTONE_TOKEN_MS = 1000
export const DEVTOOLS_KEYSTONE_TOKEN_PAD_LEN = 100
export const DEVTOOLS_NETWORK_UUID_SEGMENT_LEN = 36
export const DEVTOOLS_NETWORK_UUID_HYPHEN_POS = 9
export const DEVTOOLS_NETWORK_ERROR_SAMPLE_MAX = 400
export const DEVTOOLS_TOKEN_BASE64_PAD_MOD = 4
export const DEVTOOLS_TOKEN_BASE64_PAD_SLICE = 16
export const DEVTOOLS_TOKEN_RADIX_HEX = 16
export const DEVTOOLS_TOKEN_JWT_PARTS = 3
export const DEVTOOLS_TOKEN_HEX_NIBBLE_WIDTH = 2
export const DEVTOOLS_TOKEN_MS = 1000
export const DEVTOOLS_TOKEN_MAX_LEN = 10000

export const DEVTOOLS_KEYSTONE_CACHE_TTL_MINUTES = 5
export const DEVTOOLS_KEYSTONE_DEFAULT_CACHE_TTL_MS =
  DEVTOOLS_KEYSTONE_CACHE_TTL_MINUTES *
  DEVTOOLS_KEYSTONE_TOKEN_SECONDS *
  DEVTOOLS_KEYSTONE_TOKEN_MS
export const DEVTOOLS_KEYSTONE_VALIDATION_CACHE_MAX_ENTRIES = 100

export const DEVTOOLS_NETWORK_MAX_BODY_LOG_SIZE = DEVTOOLS_TOKEN_MAX_LEN
